import React from 'react'
import styles from './styles/question.module.scss'
import format from 'date-fns/format'
import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'


interface QuestionItemReplyProps {
  question: {
    user: {
      name: string,
      companyName: string
    },
    created: any
    uniqueConversationName: string,
    text: string
  }
}

const QuestionItemReply = ({ question }: QuestionItemReplyProps) => {
  const timeZone = useSelector((state: State) => state.user.data.timeZone)
  const questionTime = timeZone
    ? utcToZonedTime(question.created, timeZone)
    : question.created

  return (
    <div className={classNames(styles['side-panel-framework__content__question'],
                              styles['side-panel-framework__content-question__question-reply'])}>
      <div className={styles['question-list__question__heading']}>
        {question.user && <div className={styles['question-list__question__question-user']}>{question.user.name}</div>}
        <time className={styles['side-panel-framework__content__question-time']} dateTime={question.created}>
          {format(questionTime, 'HH:mm')}
        </time>
      </div>
      {question.user && <div className={styles['question-list__question__question-user-company']}>{question.user.companyName ? `${question.user.companyName}` : ''}</div>}
      <p>{question.text}</p>
    </div>
  )
}

export default QuestionItemReply
